import { render, staticRenderFns } from "./RolesAdmin.vue?vue&type=template&id=72da3355"
import script from "./RolesAdmin.vue?vue&type=script&lang=js"
export * from "./RolesAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports